import { FormHeader, FormHeaderActions } from './FormHeader';
import { AritoFormV2 } from '@/components/custom/erp';
import { useFormDialog } from './hooks/useFormDialog';
import type { FormDialogProps } from './types';
import { BottomBar } from './BottomBar';
import { FormTabs } from './FormTabs';

const FormDialog = (props: FormDialogProps) => {
  const dialog = useFormDialog(props);
  const { tongTien, tongThue, tongThanhToan } = dialog.totals;

  return (
    <AritoFormV2
      mode={dialog.formMode}
      initialData={dialog.initialValues}
      title={dialog.title}
      actionButtons={dialog.actionButtons}
      schema={dialog.schema}
      subTitle='Phiếu chi tiền'
      onSubmit={dialog.submit}
      onClose={dialog.onClose}
      headerFields={FormHeader(dialog)}
      headerTabActions={<FormHeaderActions dialog={dialog} />}
      tabs={FormTabs(dialog)}
      bottomBar={
        dialog.activeTab === 'info' ? (
          <BottomBar tongTien={tongTien} tongThue={tongThue} tongThanhToan={tongThanhToan} />
        ) : null
      }
    />
  );
};

export default FormDialog;
